{
  " Daily windows of schedule availability are determined in Appointment Hours.": " Daily windows of schedule availability are determined in Appointment Hours.",
  " mins": " mins",
  "+{{value}} more": "+{{value}} more",
  "1st {{fullDayName}} of each month": "1st {{fullDayName}} of each month",
  "1st {{fullDayName}} of every {{interval}} months": "1st {{fullDayName}} of every {{interval}} months",
  "<0>Note:</0> The system is currently set to request a payment deposit of<2> ${{globalBookingDepositAmount}}</2>, as specified in the Appointment Type Payments Settings. If you wish to customize the payment deposit for this specific appointment type, kindly ensure that you disable the global Appointment Type Payments Settings on the appointment type page.": "<0>Note:</0> The system is currently set to request a payment deposit of<2> ${{globalBookingDepositAmount}}</2>, as specified in the Appointment Type Payments Settings. If you wish to customize the payment deposit for this specific appointment type, kindly ensure that you disable the global Appointment Type Payments Settings on the appointment type page.",
  "A contact with this phone number already exists": "A contact with this phone number already exists",
  "AI Receptionist": "AI Receptionist",
  "AI-Added": "AI-Added",
  "AI-Requested": "AI-Requested",
  "Accurate availability shown online": "Accurate availability shown online",
  "Add": "Add",
  "Add Anyway": "Add Anyway",
  "Add Appointment Type": "Add Appointment Type",
  "Add Appointment Type Settings": "Add Appointment Type Settings",
  "Add Break": "Add Break",
  "Add Colors to Your Appointment Types": "Add Colors to Your Appointment Types",
  "Add Exception": "Add Exception",
  "Add Field": "Add Field",
  "Add Label Translations for the label: {{label}}": "Add Label Translations for the label: {{label}}",
  "Add Location": "Add Location",
  "Add New": "Add New",
  "Add Option Translations for Option: {{optionLabel}}": "Add Option Translations for Option: {{optionLabel}}",
  "Add Provider": "Add Provider",
  "Add Sub Field Translations for: {{subField}}": "Add Sub Field Translations for: {{subField}}",
  "Add link": "Add link",
  "Add provider to get started.": "Add provider to get started.",
  "Add {{entityLabel}} so customers know what they're booking.": "Add {{entityLabel}} so customers know what they're booking.",
  "All Day": "All Day",
  "All Providers": "All Providers",
  "All Requested Times": "All Requested Times",
  "All Workstations": "All Workstations",
  "All day": "All day",
  "All-Day": "All-Day",
  "Amount": "Amount",
  "Amount must be greater than 0": "Amount must be greater than 0",
  "Any exceptions added here will only affect this provider's schedule, it will not affect your office schedule.": "Any exceptions added here will only affect this provider's schedule, it will not affect your office schedule.",
  "Apply": "Apply",
  "Apply Assignments": "Apply Assignments",
  "Appointment Confirmed": "Appointment Confirmed",
  "Appointment Details": "Appointment Details",
  "Appointment Lead Time": "Appointment Lead Time",
  "Appointment Request Form Preview": "Appointment Request Form Preview",
  "Appointment Requests": "Appointment Requests",
  "Appointment Status": "Appointment Status",
  "Appointment Type": "Appointment Type",
  "Appointment Type Payments Settings": "Appointment Type Payments Settings",
  "Appointment Types": "Appointment Types",
  "Appointment Unconfirmed": "Appointment Unconfirmed",
  "Appointment continued from previous day": "Appointment continued from previous day",
  "Appointment continues to next day": "Appointment continues to next day",
  "Appointment couldn't be booked. Please try again later.": "Appointment couldn't be booked. Please try again later.",
  "Appointments": "Appointments",
  "Are you sure you want to delete this exception?": "Are you sure you want to delete this exception?",
  "Are you sure you want to delete {{name}}?": "Are you sure you want to delete {{name}}?",
  "Are you sure you want to delete {{providerName}}?": "Are you sure you want to delete {{providerName}}?",
  "Are you sure you want to discard the current column layout?": "Are you sure you want to discard the current column layout?",
  "Are you sure you want to remove the booking link from your Google Business profile? Please note that changes may not take effect immediately, and may require some time to process. You can always add the link back later if needed.": "Are you sure you want to remove the booking link from your Google Business profile? Please note that changes may not take effect immediately, and may require some time to process. You can always add the link back later if needed.",
  "Are you sure your want to delete {{bookableAppointmentTypeName}}?": "Are you sure your want to delete {{bookableAppointmentTypeName}}?",
  "Assign Colors": "Assign Colors",
  "Attempted contact": "Attempted contact",
  "Auto Messages": "Auto Messages",
  "Automatically map your existing appointment type colors to our new enhanced color system": "Automatically map your existing appointment type colors to our new enhanced color system",
  "Availability": "Availability",
  "Availability Finder": "Availability Finder",
  "Availability for Weave Online Scheduling is now based on your practice management system settings.": "Availability for Weave Online Scheduling is now based on your practice management system settings.",
  "Available": "Available",
  "Available Providers": "Available Providers",
  "Back to Form": "Back to Form",
  "Birth date must not be in the future": "Birth date must not be in the future",
  "Booking Link Updated as preferred to Google Business Profile": "Booking Link Updated as preferred to Google Business Profile",
  "Booking Link deleted from Google Business Profile": "Booking Link deleted from Google Business Profile",
  "Booking Link successfully added to Google Business Profile": "Booking Link successfully added to Google Business Profile",
  "Break": "Break",
  "Break is outside of scheduled hours": "Break is outside of scheduled hours",
  "Break overlaps with another break": "Break overlaps with another break",
  "Call {{name}}": "Call {{name}}",
  "Cancel": "Cancel",
  "Cancelled": "Cancelled",
  "Check your birth date, it seems out of range.": "Check your birth date, it seems out of range.",
  "Checkbox": "Checkbox",
  "Choose a location to get started": "Choose a location to get started",
  "City": "City",
  "Clear": "Clear",
  "Click \"Create Availability\" to ensure your availability rules are correctly configured.": "Click \"Create Availability\" to ensure your availability rules are correctly configured.",
  "Click here to add your first provider and start booking appointments.": "Click here to add your first provider and start booking appointments.",
  "Click here to configure your first operatory and start booking appointments.": "Click here to configure your first operatory and start booking appointments.",
  "Click here to configure your providers and start booking appointments.": "Click here to configure your providers and start booking appointments.",
  "Click to Call": "Click to Call",
  "Click “Start Mapping” below": "Click “Start Mapping” below",
  "Close": "Close",
  "Close filters": "Close filters",
  "Closed": "Closed",
  "Color": "Color",
  "Color Migration Assistant": "Color Migration Assistant",
  "Colors assigned successfully.": "Colors assigned successfully.",
  "Completed": "Completed",
  "Configure Operatories": "Configure Operatories",
  "Configure Providers": "Configure Providers",
  "Confirmed": "Confirmed",
  "Conflicting Appointment Exception": "Conflicting Appointment Exception",
  "Connect Providers & Appointments": "Connect Providers & Appointments",
  "Contacted": "Contacted",
  "Continued": "Continued",
  "Copied": "Copied",
  "Copy ID": "Copy ID",
  "Copy Link": "Copy Link",
  "Could not save custom fields. Please try again": "Could not save custom fields. Please try again",
  "Country": "Country",
  "Create": "Create",
  "Create Availability": "Create Availability",
  "Create Field": "Create Field",
  "Create Provider": "Create Provider",
  "Create the appointment types that patients will be able to choose from when scheduling online. (Ex: New Customer Consultation)": "Create the appointment types that patients will be able to choose from when scheduling online. (Ex: New Customer Consultation)",
  "Create {{entityLabel}}": "Create {{entityLabel}}",
  "Custom fields have been saved": "Custom fields have been saved",
  "Customize your message": "Customize your message",
  "Date": "Date",
  "Date & Time": "Date & Time",
  "Date of Birth": "Date of Birth",
  "Date of birth is required": "Date of birth is required",
  "Day": "Day",
  "Days": "Days",
  "Delete": "Delete",
  "Delete Appointment": "Delete Appointment",
  "Delete Appointment Type": "Delete Appointment Type",
  "Delete Booking Link": "Delete Booking Link",
  "Delete Break": "Delete Break",
  "Delete Exception": "Delete Exception",
  "Delete Provider": "Delete Provider",
  "Deleted": "Deleted",
  "Deleting this service type will not cancel these appointments<1></1><2></2>Are you sure you want to delete {bookableAppointmentTypeName}?": "Deleting this service type will not cancel these appointments<1></1><2></2>Are you sure you want to delete {bookableAppointmentTypeName}?",
  "Discard": "Discard",
  "Dismiss": "Dismiss",
  "Dismissed": "Dismissed",
  "Display Name": "Display Name",
  "Display Name is required": "Display Name is required",
  "Done": "Done",
  "Drag & drop or click to add to your message": "Drag & drop or click to add to your message",
  "Dropdown": "Dropdown",
  "Duration": "Duration",
  "Duration (minutes)": "Duration (minutes)",
  "Edit": "Edit",
  "Edit Appointment": "Edit Appointment",
  "Edit Appointment Type Colors": "Edit Appointment Type Colors",
  "Edit Appointment Type Settings": "Edit Appointment Type Settings",
  "Edit Exception": "Edit Exception",
  "Edit Provider": "Edit Provider",
  "Edit Schedule for {{providerName}}": "Edit Schedule for {{providerName}}",
  "Email *": "Email *",
  "End date must be after the start date": "End date must be after the start date",
  "End time must be after the start time": "End time must be after the start time",
  "Enter a brief description of the provider's background & expertise. Patients will see this when booking appointments online.": "Enter a brief description of the provider's background & expertise. Patients will see this when booking appointments online.",
  "Enter the location ID to request an appointment with that location.": "Enter the location ID to request an appointment with that location.",
  "Error fetching schedules": "Error fetching schedules",
  "Error in deleting the service type. Please try again.": "Error in deleting the service type. Please try again.",
  "Error loading appointments": "Error loading appointments",
  "Est. time: 5–10 minutes": "Est. time: 5–10 minutes",
  "Every day": "Every day",
  "Every {{interval}} days": "Every {{interval}} days",
  "Every {{interval}} months": "Every {{interval}} months",
  "Every {{interval}} months on {{shortDayName}}": "Every {{interval}} months on {{shortDayName}}",
  "Every {{interval}} weeks": "Every {{interval}} weeks",
  "Every {{interval}} weeks on {{joined}}": "Every {{interval}} weeks on {{joined}}",
  "Every {{ordinalSuffix}} {{fullDayName}}": "Every {{ordinalSuffix}} {{fullDayName}}",
  "Every {{ordinalSuffix}} {{fullDayName}} of every {{interval}} months": "Every {{ordinalSuffix}} {{fullDayName}} of every {{interval}} months",
  "Everything you need in one place - eligibility status, coverage details, and full eligibility reports in one easy-to-use list.": "Everything you need in one place - eligibility status, coverage details, and full eligibility reports in one easy-to-use list.",
  "Exceptions": "Exceptions",
  "External Appointment Type": "External Appointment Type",
  "Failed to add link to Google Business Profile": "Failed to add link to Google Business Profile",
  "Failed to assign colors. Please try again.": "Failed to assign colors. Please try again.",
  "Failed to create Provider": "Failed to create Provider",
  "Failed to create appointment type": "Failed to create appointment type",
  "Failed to create provider": "Failed to create provider",
  "Failed to delete appointment type": "Failed to delete appointment type",
  "Failed to delete appointment. Please try again.": "Failed to delete appointment. Please try again.",
  "Failed to delete exception": "Failed to delete exception",
  "Failed to delete link from Google Business Profile": "Failed to delete link from Google Business Profile",
  "Failed to delete provider": "Failed to delete provider",
  "Failed to load notes.": "Failed to load notes.",
  "Failed to set profile photo": "Failed to set profile photo",
  "Failed to update Provider": "Failed to update Provider",
  "Failed to update appointment color. Please try again.": "Failed to update appointment color. Please try again.",
  "Failed to update appointment type": "Failed to update appointment type",
  "Failed to update booking link as preferred to Google Business Profile": "Failed to update booking link as preferred to Google Business Profile",
  "Failed to update lead time": "Failed to update lead time",
  "Failed to update provider": "Failed to update provider",
  "Failed to update required appt. times": "Failed to update required appt. times",
  "Failed to update schedule": "Failed to update schedule",
  "Field List": "Field List",
  "Filter": "Filter",
  "Filters": "Filters",
  "Find Availability": "Find Availability",
  "Find the Appointment type's row and select \"Edit\"": "Find the Appointment type's row and select \"Edit\"",
  "First Name": "First Name",
  "First Name *": "First Name *",
  "First name is required": "First name is required",
  "For New Patients Only": "For New Patients Only",
  "For your convenience and to optimize our system's performance, we've preselected a relevant location for you to view. Modify the selection below, or continue with our suggestion.": "For your convenience and to optimize our system's performance, we've preselected a relevant location for you to view. Modify the selection below, or continue with our suggestion.",
  "For your convenience and to optimize our system's performance, we've preselected {{limit}} relevant locations for you to view. Modify your selections below, or continue with our suggestions.": "For your convenience and to optimize our system's performance, we've preselected {{limit}} relevant locations for you to view. Modify your selections below, or continue with our suggestions.",
  "Forms": "Forms",
  "Fri": "Fri",
  "Friday": "Friday",
  "Go To Location": "Go To Location",
  "Go to Availability Rules": "Go to Availability Rules",
  "Go to Exceptions": "Go to Exceptions",
  "Go to location": "Go to location",
  "Hi! Your email has been sent! We'll follow up to schedule an appointment.": "Hi! Your email has been sent! We'll follow up to schedule an appointment.",
  "History": "History",
  "Hours": "Hours",
  "ID copied": "ID copied",
  "Imported Name": "Imported Name",
  "In many cases, a higher number of requested times gives your office more scheduling flexibility.": "In many cases, a higher number of requested times gives your office more scheduling flexibility.",
  "In-Office": "In-Office",
  "Input Fields": "Input Fields",
  "Insurance": "Insurance",
  "Insurance Eligibility in One Place": "Insurance Eligibility in One Place",
  "Insurance Status": "Insurance Status",
  "Jump to next week": "Jump to next week",
  "Label": "Label",
  "Last Name": "Last Name",
  "Last Name *": "Last Name *",
  "Last name is required": "Last name is required",
  "Leave": "Leave",
  "Link Active": "Link Active",
  "Link copied": "Link copied",
  "Link will be copied to your clipboard": "Link will be copied to your clipboard",
  "Loading appointments...": "Loading appointments...",
  "Loading...": "Loading...",
  "Location": "Location",
  "Location ID": "Location ID",
  "Make your calendar easier to scan by assigning colors to your appointment types": "Make your calendar easier to scan by assigning colors to your appointment types",
  "Map Colors": "Map Colors",
  "Maximum of 1440 minutes (24 hours)": "Maximum of 1440 minutes (24 hours)",
  "Maybe Later": "Maybe Later",
  "Message Preview": "Message Preview",
  "Message {{name}}": "Message {{name}}",
  "Minimum of 10 minutes": "Minimum of 10 minutes",
  "Mins": "Mins",
  "Missing the following fields: {{fields}}": "Missing the following fields: {{fields}}",
  "Mon": "Mon",
  "Monday": "Monday",
  "Monthly": "Monthly",
  "Monthly on {{shortDayName}}": "Monthly on {{shortDayName}}",
  "Move to the Left": "Move to the Left",
  "Move to the Right": "Move to the Right",
  "Multi-day appointment": "Multi-day appointment",
  "Name": "Name",
  "Name of Exception": "Name of Exception",
  "Name of Exception (optional)": "Name of Exception (optional)",
  "Never Mind": "Never Mind",
  "New": "New",
  "New Appointment": "New Appointment",
  "New Event": "New Event",
  "New Out of Office Event": "New Out of Office Event",
  "New Patient": "New Patient",
  "New look, same data.": "New look, same data.",
  "Next Appointment": "Next Appointment",
  "No Address": "No Address",
  "No Appointment Requests found": "No Appointment Requests found",
  "No appointments": "No appointments",
  "No appointments available": "No appointments available",
  "No exception data to display": "No exception data to display",
  "No file selected": "No file selected",
  "No matching workstation names found": "No matching workstation names found",
  "No results found": "No results found",
  "No slots available": "No slots available",
  "No-show": "No-show",
  "None": "None",
  "Note": "Note",
  "Note:": "Note:",
  "Notes": "Notes",
  "Now managing availability through your PMS": "Now managing availability through your PMS",
  "Number": "Number",
  "Okay": "Okay",
  "One": "One",
  "Online Requested": "Online Requested",
  "Online Scheduling": "Online Scheduling",
  "Online Scheduling Appointment Settings": "Online Scheduling Appointment Settings",
  "Online booking isn't enabled yet for this location. Ask your admin to turn it on.": "Online booking isn't enabled yet for this location. Ask your admin to turn it on.",
  "Oops! It seems this provider isn't mapped to a Parent Office provider. No worries, you can easily fix this by selecting a Parent Office provider from the Parent Office Provider list in the edit provider screen.": "Oops! It seems this provider isn't mapped to a Parent Office provider. No worries, you can easily fix this by selecting a Parent Office provider from the Parent Office Provider list in the edit provider screen.",
  "Oops...there seems to be a problem with this link.": "Oops...there seems to be a problem with this link.",
  "Open Insurance Eligibility": "Open Insurance Eligibility",
  "Open filters": "Open filters",
  "Operatories": "Operatories",
  "Operatory": "Operatory",
  "Operatory Availability is live!": "Operatory Availability is live!",
  "Operatory Availability is up next — sign up to be the first to try it": "Operatory Availability is up next — sign up to be the first to try it",
  "Operatory View is officially live!": "Operatory View is officially live!",
  "Operatory View is officially live! Operatory Availability is up next — sign up to be the first to try it": "Operatory View is officially live! Operatory Availability is up next — sign up to be the first to try it",
  "Options": "Options",
  "Other": "Other",
  "Out of Office": "Out of Office",
  "Overlapping Appointments": "Overlapping Appointments",
  "Overlapping Requests": "Overlapping Requests",
  "Parent Office Provider List": "Parent Office Provider List",
  "Past": "Past",
  "Patients book with the right providers": "Patients book with the right providers",
  "Payment Amount": "Payment Amount",
  "Payments": "Payments",
  "Pending Requests": "Pending Requests",
  "Phone": "Phone",
  "Phone *": "Phone *",
  "Phone number is required": "Phone number is required",
  "Please add an appointment type before updating the appointment lead time.": "Please add an appointment type before updating the appointment lead time.",
  "Please add an appointment type before updating the required number of appointment times.": "Please add an appointment type before updating the required number of appointment times.",
  "Please enter your information below and we will follow up to schedule an appointment.": "Please enter your information below and we will follow up to schedule an appointment.",
  "Please fill out the form before submitting": "Please fill out the form before submitting",
  "Please go back to the source and try the link again.": "Please go back to the source and try the link again.",
  "Please logout and login again to your Google Business Profile location in Social Platforms settings. Click \"Take Me There\" button to complete the profile connection. ": "Please logout and login again to your Google Business Profile location in Social Platforms settings. Click \"Take Me There\" button to complete the profile connection. ",
  "Please remove the country code and ensure your phone number is correct.": "Please remove the country code and ensure your phone number is correct.",
  "Please select a provider": "Please select a provider",
  "Please select external appointment type": "Please select external appointment type",
  "Postal Code": "Postal Code",
  "Preview Form": "Preview Form",
  "Preview Site": "Preview Site",
  "Profile Picture": "Profile Picture",
  "Provider": "Provider",
  "Provider Biography": "Provider Biography",
  "Provider Mapping Error": "Provider Mapping Error",
  "Provider Schedule": "Provider Schedule",
  "Provider availability for Weave Online Scheduling is now based on your practice management system settings.": "Provider availability for Weave Online Scheduling is now based on your practice management system settings.",
  "Provider created successfully": "Provider created successfully",
  "Provider details updated successfully": "Provider details updated successfully",
  "Provider schedule": "Provider schedule",
  "Providers": "Providers",
  "Providers: {{length}}": "Providers: {{length}}",
  "Quick Steps:": "Quick Steps:",
  "Ready to start scheduling?": "Ready to start scheduling?",
  "Refresh providers": "Refresh providers",
  "Remove": "Remove",
  "Remove Booking Link": "Remove Booking Link",
  "Remove Link": "Remove Link",
  "Remove Photo": "Remove Photo",
  "Remove Profile Photo": "Remove Profile Photo",
  "Remove this service type from all availability rules before deleting.": "Remove this service type from all availability rules before deleting.",
  "Remove this service type from all exceptions before deleting.": "Remove this service type from all exceptions before deleting.",
  "Request Accepted": "Request Accepted",
  "Request Only": "Request Only",
  "Request Payment": "Request Payment",
  "Request Payments": "Request Payments",
  "Request Pending": "Request Pending",
  "Request Rejected": "Request Rejected",
  "Request Review": "Request Review",
  "Request below amount for the appointment type": "Request below amount for the appointment type",
  "Requested Appointment": "Requested Appointment",
  "Required": "Required",
  "Required Number Of Appointment Times": "Required Number Of Appointment Times",
  "Required Number Of Appt. Times": "Required Number Of Appt. Times",
  "Required Times": "Required Times",
  "Required fields": "Required fields",
  "Reset": "Reset",
  "Reset Colors": "Reset Colors",
  "Sat": "Sat",
  "Saturday": "Saturday",
  "Save": "Save",
  "Save Layout": "Save Layout",
  "Save your changes": "Save your changes",
  "Saving...": "Saving...",
  "Schedules must be set before Exceptions to provide a base availability.": "Schedules must be set before Exceptions to provide a base availability.",
  "Search": "Search",
  "Search by Name": "Search by Name",
  "Select All": "Select All",
  "Select Availability": "Select Availability",
  "Select Date Range": "Select Date Range",
  "Select Profile Photo": "Select Profile Photo",
  "Select Provider": "Select Provider",
  "Select Time Range": "Select Time Range",
  "Select a Location *": "Select a Location *",
  "Select at least one location": "Select at least one location",
  "Select available providers for that appointment type": "Select available providers for that appointment type",
  "Select available providers:": "Select available providers:",
  "Select color": "Select color",
  "Select the locations you want to view on the calendar. You can select up to {{limit}} locations.": "Select the locations you want to view on the calendar. You can select up to {{limit}} locations.",
  "Select the number of different appointment times (max of 3) a patient must select in order to submit an appointment request.": "Select the number of different appointment times (max of 3) a patient must select in order to submit an appointment request.",
  "Select up to {{limit}} Locations": "Select up to {{limit}} Locations",
  "Select<1> Add Appointment Type </1>below to create the appointment types that patients will choose from when making appointment requests online.": "Select<1> Add Appointment Type </1>below to create the appointment types that patients will choose from when making appointment requests online.",
  "Self Bookable": "Self Bookable",
  "Send Email": "Send Email",
  "Send Form": "Send Form",
  "Send Message": "Send Message",
  "Service": "Service",
  "Set Profile Photo": "Set Profile Photo",
  "Set Provider Schedule": "Set Provider Schedule",
  "Set Up Online Scheduling": "Set Up Online Scheduling",
  "Set as Preferred Link": "Set as Preferred Link",
  "Set up your first appointment type to start taking bookings.": "Set up your first appointment type to start taking bookings.",
  "Set your availability for this location so patients know when they can book.": "Set your availability for this location so patients know when they can book.",
  "Set your availability so patients know when they can book.": "Set your availability so patients know when they can book.",
  "Setup Availability": "Setup Availability",
  "Sign Up": "Sign Up",
  "Sign in to your Google Business Account in Social Platforms settings. Don't forget to return here to finish your booking link setup.": "Sign in to your Google Business Account in Social Platforms settings. Don't forget to return here to finish your booking link setup.",
  "Skip": "Skip",
  "Smoother experience for everyone": "Smoother experience for everyone",
  "Something went wrong while deleting the exception": "Something went wrong while deleting the exception",
  "Source": "Source",
  "Staff Only": "Staff Only",
  "Start Mapping": "Start Mapping",
  "Start and end dates": "Start and end dates",
  "Start and end times": "Start and end times",
  "State": "State",
  "Stay": "Stay",
  "Street": "Street",
  "Sub Fields": "Sub Fields",
  "Success!": "Success!",
  "Successfully created appointment type": "Successfully created appointment type",
  "Successfully created exception": "Successfully created exception",
  "Successfully created provider": "Successfully created provider",
  "Successfully deleted appointment": "Successfully deleted appointment",
  "Successfully deleted appointment type": "Successfully deleted appointment type",
  "Successfully deleted exception": "Successfully deleted exception",
  "Successfully deleted provider": "Successfully deleted provider",
  "Successfully updated appointment type": "Successfully updated appointment type",
  "Successfully updated exception": "Successfully updated exception",
  "Successfully updated lead time": "Successfully updated lead time",
  "Successfully updated provider": "Successfully updated provider",
  "Successfully updated required appt. times": "Successfully updated required appt. times",
  "Successfully updated schedule": "Successfully updated schedule",
  "Sun": "Sun",
  "Sunday": "Sunday",
  "Take Me There": "Take Me There",
  "Text": "Text",
  "The provider's first name as it appears in your Practice Management System.": "The provider's first name as it appears in your Practice Management System.",
  "The provider's last name as it appears in your Practice Management System.": "The provider's last name as it appears in your Practice Management System.",
  "The time you select will be the soonest a patient can request an appointment. This is a \"safety\" window to prevent same-day or same-hour requests.": "The time you select will be the soonest a patient can request an appointment. This is a \"safety\" window to prevent same-day or same-hour requests.",
  "Then set your availability so patients can book at the right time.": "Then set your availability so patients can book at the right time.",
  "There are no available workstations": "There are no available workstations",
  "This action cannot be undone.": "This action cannot be undone.",
  "This amount will be applied to the total amount owed.": "This amount will be applied to the total amount owed.",
  "This appointment will be removed from the schedule. This action cannot be undone.": "This appointment will be removed from the schedule. This action cannot be undone.",
  "This field is required": "This field is required",
  "This name will be visible to customers when booking online, and on your Weave calendar": "This name will be visible to customers when booking online, and on your Weave calendar",
  "This provider exception will take precedence without affecting the appointment exception.": "This provider exception will take precedence without affecting the appointment exception.",
  "This service type cannot be deleted because it is currently used in {{count}} availability rules_one": "This service type cannot be deleted because it is currently used in {{count}} availability rule",
  "This service type cannot be deleted because it is currently used in {{count}} availability rules_other": "This service type cannot be deleted because it is currently used in {{count}} availability rules",
  "This service type cannot be deleted because it is currently used in {{count}} exceptions_one": "This service type cannot be deleted because it is currently used in {{count}} exception",
  "This service type cannot be deleted because it is currently used in {{count}} exceptions_other": "This service type cannot be deleted because it is currently used in {{count}} exceptions",
  "This service type has existing appointments associated with it": "This service type has existing appointments associated with it",
  "Three": "Three",
  "Thu": "Thu",
  "Thursday": "Thursday",
  "Time": "Time",
  "Time Unit": "Time Unit",
  "Time of Day": "Time of Day",
  "Times now displayed in location timezones": "Times now displayed in location timezones",
  "Times shown are in": "Times shown are in",
  "Timezone": "Timezone",
  "To finish setup, go to Availability Settings, change “Availability Calculated By” to Operatory, and review your availability.": "To finish setup, go to Availability Settings, change “Availability Calculated By” to Operatory, and review your availability.",
  "Today": "Today",
  "Today {{time}}": "Today {{time}}",
  "Tomorrow {{time}}": "Tomorrow {{time}}",
  "Tue": "Tue",
  "Tuesday": "Tuesday",
  "Two": "Two",
  "Type": "Type",
  "Unable to fetch appointment hours. Please try again later.": "Unable to fetch appointment hours. Please try again later.",
  "Unable to fetch appointment lead time. Please try again later.": "Unable to fetch appointment lead time. Please try again later.",
  "Unable to fetch provider schedule. Please try again later.": "Unable to fetch provider schedule. Please try again later.",
  "Unable to fetch required number of appointment times. Please try again later.": "Unable to fetch required number of appointment times. Please try again later.",
  "Unavailable": "Unavailable",
  "Unconfirmed": "Unconfirmed",
  "Unit": "Unit",
  "Unknown": "Unknown",
  "Unsaved Changes": "Unsaved Changes",
  "Upcoming": "Upcoming",
  "Update": "Update",
  "Updated On": "Updated On",
  "Upload Image": "Upload Image",
  "Upload Profile Photo": "Upload Profile Photo",
  "Upload Profile Photo for {{name}}": "Upload Profile Photo for {{name}}",
  "Upload a photo for this provider. It will appear in online scheduling and the Weave calendar.": "Upload a photo for this provider. It will appear in online scheduling and the Weave calendar.",
  "Urgent": "Urgent",
  "Value": "Value",
  "Verified": "Verified",
  "View": "View",
  "View Appointment": "View Appointment",
  "View Settings": "View Settings",
  "View on Calendar": "View on Calendar",
  "View one location": "View one location",
  "View {{word}} locations": "View {{word}} locations",
  "We couldn't submit your form": "We couldn't submit your form",
  "We were unable to sync appointment types from your PMS. Please ensure there are appointment types in your PMS. If there are please call Weave Support.": "We were unable to sync appointment types from your PMS. Please ensure there are appointment types in your PMS. If there are please call Weave Support.",
  "We've Picked a Location for You": "We've Picked a Location for You",
  "We've Picked {{limit}} Locations for You": "We've Picked {{limit}} Locations for You",
  "We've updated your scheduling availability settings with new tools to define providers, services, availability rules, and booking controls from the ground up. Your existing data is preserved and nothing needs to change. <2>Learn what's new →</2>": "We've updated your scheduling availability settings with new tools to define providers, services, availability rules, and booking controls from the ground up. Your existing data is preserved and nothing needs to change. <2>Learn what's new →</2>",
  "Weave": "Weave",
  "Wed": "Wed",
  "Wednesday": "Wednesday",
  "Whole dollar amounts only": "Whole dollar amounts only",
  "Why it matters:": "Why it matters:",
  "Workstation": "Workstation",
  "Yesterday {{time}}": "Yesterday {{time}}",
  "You can customize any of these suggestions or change individual appointment types later in settings.": "You can customize any of these suggestions or change individual appointment types later in settings.",
  "You have selected a past date. You can proceed, but please ensure this is intentional.": "You have selected a past date. You can proceed, but please ensure this is intentional.",
  "You have unsaved changes": "You have unsaved changes",
  "You have unsaved changes to these appointment hours. If you leave now, these changes will be lost": "You have unsaved changes to these appointment hours. If you leave now, these changes will be lost",
  "You haven't set up appointment types yet": "You haven't set up appointment types yet",
  "You may only add the booking link to the same location linked to your reviews account.": "You may only add the booking link to the same location linked to your reviews account.",
  "You now have access to Operatory Availability! Head to Availability Settings to switch “Availability Calculated By” to Operatory, then review your availability to make sure everything looks right.": "You now have access to Operatory Availability! Head to Availability Settings to switch “Availability Calculated By” to Operatory, then review your availability to make sure everything looks right.",
  "You now have access to Operatory Availability! To use it, switch “Availability Calculated By” to Operatory, then review your availability to make sure everything looks right.": "You now have access to Operatory Availability! To use it, switch “Availability Calculated By” to Operatory, then review your availability to make sure everything looks right.",
  "You'll also need at least one provider to be set up.": "You'll also need at least one provider to be set up.",
  "You'll also need at least one {{entityLabel}} to be set up.": "You'll also need at least one {{entityLabel}} to be set up.",
  "You're almost there! Before you can add the booking link to your website for this location, you'll first need to connect your providers to {{entityLabel}}s.": "You're almost there! Before you can add the booking link to your website for this location, you'll first need to connect your providers to {{entityLabel}}s.",
  "You're almost there! Before you can add the booking link to your website, you'll first need to connect your providers to {{entityLabel}}s.": "You're almost there! Before you can add the booking link to your website, you'll first need to connect your providers to {{entityLabel}}s.",
  "Your Google Business Profile needs to be verified before you can add a booking link. Please verify your Google Business Profile to proceed.": "Your Google Business Profile needs to be verified before you can add a booking link. Please verify your Google Business Profile to proceed.",
  "Your booking link has been added to your Google Business profile. Please note that changes may not appear immediately. Allow some time for the update to take effect.": "Your booking link has been added to your Google Business profile. Please note that changes may not appear immediately. Allow some time for the update to take effect.",
  "Your calendar is looking a bit empty!": "Your calendar is looking a bit empty!",
  "Your calendar now shows appointment times based on each location's timezone, with visual indicators to help you track time differences.": "Your calendar now shows appointment times based on each location's timezone, with visual indicators to help you track time differences.",
  "Your changes will not be saved. Are you sure you want to leave this page?": "Your changes will not be saved. Are you sure you want to leave this page?",
  "Your progress was saved, but because of a technical issue on our end, we couldn't submit your form. Check to make sure your information is accurate and try again.": "Your progress was saved, but because of a technical issue on our end, we couldn't submit your form. Check to make sure your information is accurate and try again.",
  "appointment request lead time": "appointment request lead time",
  "coming soon": "coming soon",
  "date range": "date range",
  "default provider name": "default provider name",
  "four": "four",
  "last": "last",
  "one": "one",
  "required number of appointment times": "required number of appointment times",
  "three": "three",
  "time range": "time range",
  "to": "to",
  "two": "two",
  "zero": "zero",
  "{{age}} yrs": "{{age}} yrs",
  "{{count}} Calendar Exceptions:_one": "{{count}} Calendar Exception:",
  "{{count}} Calendar Exceptions:_other": "{{count}} Calendar Exceptions:",
  "{{count}} Sources_one": "{{count}} Source",
  "{{count}} Sources_other": "{{count}} Sources",
  "{{count}} appointment requests • {{timeRange}}_one": "{{count}} appointment request • {{timeRange}}",
  "{{count}} appointment requests • {{timeRange}}_other": "{{count}} appointment requests • {{timeRange}}",
  "{{count}} appointments • {{timeRange}}_one": "{{count}} appointment • {{timeRange}}",
  "{{count}} appointments • {{timeRange}}_other": "{{count}} appointments • {{timeRange}}",
  "{{count}} min_one": "{{count}} min",
  "{{count}} min_other": "{{count}} mins",
  "{{date}}, {{time}}": "{{date}}, {{time}}",
  "{{day}} Break Time Range": "{{day}} Break Time Range",
  "{{day}} Time Range": "{{day}} Time Range",
  "{{gender}} gender": "{{gender}} gender",
  "{{locationName}}": "{{locationName}}",
  "{{mode}} Field": "{{mode}} Field",
  "{{n}}nd": "{{n}}nd",
  "{{n}}rd": "{{n}}rd",
  "{{n}}st": "{{n}}st",
  "{{n}}th": "{{n}}th",
  "{{ordinalSuffix}} day of each month": "{{ordinalSuffix}} day of each month",
  "{{ordinalSuffix}} day of every {{interval}} months": "{{ordinalSuffix}} day of every {{interval}} months"
}
